/**
 * Mega Menu Product Display
 * Displays featured products from theme settings
 */

class MegaMenuManager {
  constructor() {
    this.products = window.megaMenuProducts || [];
    this.init();
  }

  init() {
    // Render featured products from theme settings
    this.renderProducts();
  }

  /**
   * Render products into the mega menu showcase
   */
  renderProducts() {
    const productCards = document.querySelectorAll(".mega-menu__product-card");

    productCards.forEach((card, index) => {
      const product = this.products[index] || {};
      const imageEl = card.querySelector(".mega-menu__product-image");
      const nameEl = card.querySelector(".mega-menu__product-name");
      const priceEl = card.querySelector(".mega-menu__product-price");

      if (product.image) {
        imageEl.innerHTML = `<img src="${product.image}" alt="${product.title || "Product"}" style="width:100%; height:100%; object-fit:cover; border-radius:4px;">`;
      } else {
        imageEl.innerHTML =
          '<div style="display:flex;align-items:center;justify-content:center;width:100%;height:100%;color:#999;font-size:12px;">No product selected</div>';
      }

      nameEl.textContent = product.title || "Product " + (index + 1);
      priceEl.textContent = product.price || "$0.00";

      // Make product card clickable to navigate to product page
      if (product.handle) {
        card.style.cursor = "pointer";
        card.onclick = () => {
          window.location.href = `/products/${product.handle}`;
        };
      } else {
        card.style.cursor = "default";
      }
    });
  }
}

// Initialize on page load
document.addEventListener("DOMContentLoaded", () => {
  window.megaMenuManager = new MegaMenuManager();
  // Enable hover-to-open behavior on devices that support hover
  try {
    const supportsHover =
      window.matchMedia &&
      window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    if (supportsHover) {
      const menus = document.querySelectorAll("details.mega-menu");
      menus.forEach((details) => {
        // open on mouseenter, close on mouseleave
        details.addEventListener("mouseenter", () => {
          details.setAttribute("open", "");
        });
        details.addEventListener("mouseleave", () => {
          // don't close if focus is inside (keyboard users)
          if (!details.contains(document.activeElement)) {
            details.removeAttribute("open");
          }
        });
        // If keyboard user opens via summary, keep it accessible
        const summary = details.querySelector("summary");
        if (summary) {
          summary.addEventListener("focusout", (e) => {
            // close when moving focus outside the details
            requestAnimationFrame(() => {
              if (!details.contains(document.activeElement)) {
                details.removeAttribute("open");
              }
            });
          });
        }
      });
    }
  } catch (e) {
    // silence errors to avoid breaking other scripts
  }
});
